"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, useAnimation } from "framer-motion";
import { useEffect, useState } from "react";
import Image from "@/components/common/image/image";
import { addQueryParams } from "@/utilities/url";
import useOnScreen from "@/hooks/useOnScreen";
import { ImageLoading } from "@/utilities/imageLoading";
interface AnimatedMobileShowcaseProps {
  backgroundSrc: string;
  leftMobileSrc: string;
  rightMobileSrc: string;
  className?: string;
}
const AnimatedMobileShowcase = t0 => {
  const $ = _c(17);
  const {
    backgroundSrc,
    leftMobileSrc,
    rightMobileSrc,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const controls = useAnimation();
  const {
    ref,
    inView
  } = useOnScreen();
  const [screenSize, setScreenSize] = useState("mobile");
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleResize = () => {
        if (window.innerWidth >= 1024) {
          setScreenSize("desktop");
        } else {
          setScreenSize("mobile");
        }
      };
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[2] !== controls || $[3] !== inView) {
    t4 = () => {
      if (inView) {
        controls.start("visible");
      }
    };
    t5 = [controls, inView];
    $[2] = controls;
    $[3] = inView;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  const t6 = `relative flex items-center justify-center ${className}`;
  let t7;
  if ($[6] !== backgroundSrc || $[7] !== controls || $[8] !== inView || $[9] !== leftMobileSrc || $[10] !== rightMobileSrc || $[11] !== screenSize) {
    t7 = inView && <><Image src={addQueryParams(backgroundSrc, {
        w: "600",
        h: "754"
      })} alt="Background pattern" width={750} height={942} className="absolute w-[500px] opacity-60 sm:w-[600px]" srcSet={`
          ${addQueryParams(backgroundSrc, {
        w: "464"
      })} 464w,
          ${addQueryParams(backgroundSrc, {
        w: "560"
      })} 560w,
          ${addQueryParams(backgroundSrc, {
        w: "552"
      })} 552w,
          ${addQueryParams(backgroundSrc, {
        w: "600"
      })} 600w
        `} sizes="(max-width: 640px) 560px, (max-width: 768px) 464px, (max-width: 1024px) 464px, (max-width: 1440px) 552px, 600px" fetchPriority="low" loading={ImageLoading.LAZY} /><motion.div initial="hidden" animate={controls} variants={{
        hidden: {
          opacity: 0.5,
          y: 0,
          x: 0,
          scale: 1
        },
        visible: {
          opacity: 1,
          x: screenSize === "desktop" ? "-100px" : "-50px",
          y: screenSize === "desktop" ? "-50px" : "-30px",
          scale: 1,
          transition: {
            duration: 1,
            ease: "linear"
          }
        }
      }} className="absolute z-10"><Image src={addQueryParams(leftMobileSrc, {
          w: "483",
          h: "833"
        })} alt="Left mobile" width={483} height={833} className="drop-shadow-xl" srcSet={`
            ${addQueryParams(leftMobileSrc, {
          w: "464",
          h: "800"
        })} 464w,
            ${addQueryParams(leftMobileSrc, {
          w: "483",
          h: "833"
        })} 483w
          `} sizes="(max-width: 768px) 483px, (max-width: 1024px) 464px, 483px" fetchPriority="low" loading={ImageLoading.LAZY} /></motion.div><motion.div initial="hidden" animate={controls} variants={{
        hidden: {
          opacity: 1,
          y: 0,
          x: 0,
          scale: 1
        },
        visible: {
          opacity: 1,
          x: screenSize === "desktop" ? "100px" : "50px",
          y: 0,
          scale: 1,
          transition: {
            duration: 1,
            ease: "linear"
          }
        }
      }} className="absolute z-20"><Image src={addQueryParams(rightMobileSrc, {
          w: "483",
          h: "796"
        })} alt="Right mobile" width={483} height={796} className="drop-shadow-xl" srcSet={`
            ${addQueryParams(rightMobileSrc, {
          w: "464",
          h: "800"
        })} 464w,
            ${addQueryParams(rightMobileSrc, {
          w: "483",
          h: "833"
        })} 483w
          `} sizes="(max-width: 768px) 483px, (max-width: 1024px) 464px, 483px" fetchPriority="low" loading={ImageLoading.LAZY} /></motion.div></>;
    $[6] = backgroundSrc;
    $[7] = controls;
    $[8] = inView;
    $[9] = leftMobileSrc;
    $[10] = rightMobileSrc;
    $[11] = screenSize;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== ref || $[14] !== t6 || $[15] !== t7) {
    t8 = <div ref={ref} className={t6}>{t7}</div>;
    $[13] = ref;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default AnimatedMobileShowcase;